// The animal slice is based at /admin/api/v2, and this endpoint is shared with the PM and tenant
// apps at /common/api/v2, so it is named in full rather than relative to that base.
export const COMMON_ALLOWED_ANIMAL_ACTIONS_URL = `${
  import.meta.env.REACT_APP_HOSTNAME
}/common/api/v2/tenant-residencies/allowed-animal-status-update-actions`;
